import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { MatPaginator } from '@angular/material/paginator'
import { MatTableDataSource } from '@angular/material/table'
import { ActivatedRoute } from '@angular/router'
import { finalize, Subject, takeUntil } from 'rxjs'
import { DishModel } from 'src/app/models/dish.model'
import { MenuModel } from 'src/app/models/menu.model'
import { AyBService } from 'src/app/services/api/ayb.service'
import Swal from 'sweetalert2'
import { FormCocinaService } from '../../services/forms/form-cocina.service'
import { LoadingService } from '../../services/interceptors/loading.service'
import { DialogAgregarPlatoComponent } from './dialog-agregar-plato/dialog-agregar-plato.component'

@Component({
  selector: 'app-detalle-menu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './detalle-menu.component.html',
  styleUrls: ['./detalle-menu.component.scss']
})
export class DetalleMenuComponent implements OnInit, OnDestroy {
  private _unsubscribeOnDestroy$ = new Subject<boolean>()

  menuForm!: FormGroup
  isLoading = true
  isReadOnly = true
  buttonTitle: string = 'Modificar'
  menuId!: any
  nombreMenu!: any
  dishes: DishModel[] = []
  updatedDishes: any
  displayedColumns: string[] = [
    'nombrePlato',
    'categoria',
    'observaciones',
    // 'costo',
    'eliminar'
  ]

  dataSource = new MatTableDataSource<MenuModel>()
  paginator!: MatPaginator
  @ViewChild(MatPaginator) set matPaginator (paginator: MatPaginator) {
    this.paginator = paginator
    if (this.dataSource) this.dataSource.paginator = paginator
  }
  constructor (
    private readonly fb: FormBuilder,
    private readonly formCocinaService: FormCocinaService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly aybService: AyBService,
    private readonly cdRef: ChangeDetectorRef,
    public dialogAgregarPlatoComponentRef: MatDialog,
    public loadingService: LoadingService
  ) {}

  ngOnInit (): void {
    this.menuForm = this.fb.group({
      menu: this.formCocinaService.getMenuForm()
    })
    this.menuId = this.activatedRoute.snapshot.paramMap.get('id')

    console.log({
      menuId: this.menuId
    })
    this.getAllPlatosByMenuId()
  }

  ngOnDestroy (): void {
    this._unsubscribeOnDestroy$.next(true)
    this._unsubscribeOnDestroy$.complete()
  }

  applyFilter (event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataSource.filter = filterValue.trim().toLowerCase()
  }

  getAllPlatosByMenuId (): void {
    this.isLoading = true
    this.cdRef.markForCheck()

    this.aybService
      .queryGetAllPlatosByMenuId({
        menuId: this?.menuId ?? ''
      })
      .pipe(
        takeUntil(this._unsubscribeOnDestroy$),
        finalize(() => {
          this.isLoading = false
          this.cdRef.markForCheck()
        })
      )
      .subscribe({
        next: ({ getMenuById }) => {
          this.nombreMenu = getMenuById.nombreMenu
          this.menuForm
            .get(['menu', 'nombre'])
            ?.setValue(getMenuById.nombreMenu)
          this.menuForm
            .get(['menu', 'descripcion'])
            ?.setValue(getMenuById.descripcion)

          this.menuForm.get(['menu', 'nombre'])?.disable()
          this.menuForm.get(['menu', 'descripcion'])?.disable()

          this.dishes = getMenuById?.platos || []
          this.dataSource.data = this.dishes
          console.log({
            dishes: this.dishes
          })
        },
        error: error => {
          console.error('Error fetching dishes:', error)
        }
      })
  }

  openDialogAdd (): void {
    let dialogConfig = new MatDialogConfig()
    dialogConfig.data = {
      id: this.menuId
    }
    dialogConfig.width = '40rem'
    let dialogRef = this.dialogAgregarPlatoComponentRef.open(
      DialogAgregarPlatoComponent,
      dialogConfig
    )
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this._unsubscribeOnDestroy$))
      .subscribe(result => {
        console.log(result)
        if (result == 1) {
          this.getAllPlatosByMenuId()
        }
      })
  }

  deletePlatoFromMenu (dishId: string) {
    this.updatedDishes = this.dishes.find(dish => dish.id === dishId)
    this.cdRef.markForCheck()
    const menu = {
      platos: this.updatedDishes
    }
    console.log('this.updatedDishes')
    console.log(this.updatedDishes)
    // this.menuService.updatePlatosFromMenu(this.menuId,menu).subscribe(response=>{
    //   console.log(response);
    // })
  }

  deletePlato (i: number): void {
    Swal.fire({
      title: '¿Estás seguro de que quieres borrar este registro?',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      confirmButtonColor: '#e95a1a',
      cancelButtonText: 'No'
    })
      .then(result => {
        if (result.isConfirmed) {
          const pageIndex = this.dataSource?.paginator?.pageIndex || 0
          const pageSize = this.dataSource?.paginator?.pageSize || 0
          const globalIndex = pageIndex * pageSize + i

          this.dataSource.data.splice(globalIndex, 1)

          const dishMenu = {
            platos: this.dataSource.data
          }

          console.log(dishMenu.platos)
          this.aybService
            .mutationUpdatePlatosFromMenu({
              menuId: this.menuId,
              updatedMenu: dishMenu
            })
            .pipe(takeUntil(this._unsubscribeOnDestroy$))
            .subscribe({
              next: response => {
                console.log(response)
              },
              error: err => {
                console.error(err)
                Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: 'No se pudo eliminar el plato. Inténtalo de nuevo o contacta al soporte.'
                })
              }
            })

          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'El registro se eliminó satisfactoriamente.',
            showConfirmButton: false,
            timer: 4000
          })

          this.dataSource._updateChangeSubscription()
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          console.log('false')
        }
      })
      .finally(() => {
        this.cdRef.markForCheck()
      })
  }

  updateMenu () {
    if (this.dishes == null) {
      this.dishes = []
    }

    const menu = {
      nombreMenu: this.menuForm.value.menu.nombre,
      descripcion: this.menuForm.value.menu.descripcion,
      platos: this.dishes
    }
    if (this.buttonTitle == 'Modificar') {
      this.menuForm.get(['menu', 'nombre'])?.enable()
      this.menuForm.get(['menu', 'descripcion'])?.enable()
      this.isReadOnly = false
      this.buttonTitle = 'Aceptar'
    } else {
      this.aybService
        .mutationUpdateMenu(this.menuId, menu)
        .pipe(takeUntil(this._unsubscribeOnDestroy$))
        .subscribe(response => {
          this.menuForm.get(['menu', 'nombre'])?.disable()
          this.menuForm.get(['menu', 'descripcion'])?.disable()
          this.isReadOnly = true
          this.buttonTitle = 'Modificar'
          console.log(response)
        })
    }

    this.cdRef.markForCheck()
  }
}
